import CreateUpdateForm from "../components/PaymentDateLimit/CreateUpdateForm";
import ReactivateButton from "../components/PaymentDateLimit/ReactivateButton";
import ArchiveButton from "../components/PaymentDateLimit/ArchiveButton";
import DeleteButton from "../components/PaymentDateLimit/DeleteButton";
import { useTranslation } from "react-i18next";
import { DATE_FORMAT } from "config/settings";
import { Space } from "antd";
import dayjs from "dayjs";

export default function usePaymentLimitTableColumns(refetch: () => void): (Record<any, any> | boolean)[] {
  const { t } = useTranslation();

  return [
    {
      key: "name",
      title: t("Name"),
    },
    {
      key: "beginningDay",
      title: t("Start day"),
    },
    {
      key: "numberOfDays",
      title: t("Total days"),
    },
    {
      key: "payDay",
      title: t("Pay day"),
    },
    {
      key: "archivedAt",
      title: t("Archived at"),
      render: (_text: unknown, record: Record<string, any>) => record?.archivedAt && dayjs(record.archivedAt).format(DATE_FORMAT),
    },
    {
      key: "Actions",
      title: t("Actions"),
      width: "100px",
      align: "center",
      render: (_text: unknown, record: Record<string, any>) => {
        return (
          <Space size="small" direction="horizontal" className="centered">
            {record?.editable && <CreateUpdateForm id={record.id} refetch={refetch} />}
            {record.canBeDeleted && <DeleteButton id={record.id} refetch={refetch} />}
            {record?.canBeArchived && <ArchiveButton id={record.id} refetch={refetch} />}
            {!record.canBeDeleted && record?.archivedAt && (
              <ReactivateButton id={record.id} refetch={refetch} />
            )}
          </Space>
        );
      },
    },
  ];
}
